import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 20px 0 0;

  table td p {
    margin: 16px 0;
  }
`;
